module.exports = "/lucky-balls/img/drum/drum_loop_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_012.png
// module id = 1027
// module chunks = 0